import { useQuery } from '@tanstack/react-query';
import { EstatesService } from '../../services/generatedApi';

const useEstate = (estateId: string, intake: boolean) => {
  //! estate is static key, id needs to be dynamic, will get estateId as id from url later. getEstate need estateId later
  return useQuery(
    ['estate', estateId],
    () =>
      EstatesService.estatesGetEstate(estateId, intake).then(
        (response) => response
      ),
    {
      enabled: !!estateId,
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      cacheTime: 1000 * 5 * 60,
      staleTime: 1000 * 5 * 60,
    }
  );
};

export default useEstate;
